import { useAuth } from '../../../hooks';
import { useFetchCoaches } from '../../../api/healthCoach/useFetchCoaches';

export const useDashboardCoach = () => {
  const { user: authenticatedUser } = useAuth();
  const { data } = useFetchCoaches({active: true});

  const coachOptions = data?.map(
    ({ id, first_name, last_name, healthie_id }) => ({
      label: `${first_name} ${last_name}`,
      value: id,
      healthieId: healthie_id,
    })
  );

  // this checks that the user which is authenticated is a coach as the
  // initialSelectedCoachOption should not be defined if the authenticated user is a provider or another user
  const initialSelectedCoachOption = coachOptions?.find(
    (opt) => opt.value === authenticatedUser?.id
  );

  return {
    coachOptions,
    initialSelectedCoachId: initialSelectedCoachOption?.value,
    // true once the fetch has resolved (even if the authenticated user isn't a coach)
    isCoachDataLoaded: coachOptions !== undefined,
  };
};
